module.exports = __webpack_public_path__ + "img/Simulation-Beam.22131c91.jpeg";